
import { ContactForm } from "@/components/contact/ContactForm";
import { TelegramSection } from "@/components/contact/TelegramSection";
import { PageHeader } from "@/components/common/PageHeader";
import { StandardCard } from "@/components/common/StandardCard";

const Contact = () => {
  return (
    <div className="min-h-screen bg-white text-black">
      <div className="container-max section-spacing">
        <PageHeader
          title="Contact Us"
          subtitle="Get in touch with our team. We're here to help you succeed with doozy."
        />
        
        <div className="grid md:grid-cols-2 gap-8 max-w-4xl mx-auto">
          <StandardCard>
            <h2 className="text-heading-3 mb-6 text-black">Send us a Message</h2>
            <ContactForm />
          </StandardCard>

          <StandardCard>
            <TelegramSection />
          </StandardCard>
        </div>
      </div>
    </div>
  );
};

export default Contact;
